import AppType from "../enums/AppType";

const isSilvrr = process.env.BUILD_APP === AppType.Silvrr;

export default isSilvrr;
